export const MAX_AUTOMATION_NAME_LENGTH = 500;
